<template>
  <div>
    <div>
      <div v-if="loaded && companyBannedUsers.length === 0">
        <div class="alert alert-primary" role="alert">کاربری یافت نشد.</div>
      </div>
    </div>
    <div></div>
    <div
      v-if="loaded && companyBannedUsers.length"
      class="card card-custom gutter-b"
    >
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>نام</th>
                <th>تلفن</th>
                <th>دلیل بلاک شدن</th>
                <th>تاریخ بلاک</th>
                <th>عملیات ها</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="bannedUser in companyBannedUsers" :key="bannedUser.id">
                <!-- <pre>{{bannedUser}}</pre> -->
                <td>{{ gFullName(bannedUser.user) || "_" }}</td>
                <td dir="ltr">
                  <a :href="`tel:${bannedUser.user.cellphone}`">
                    {{ prettyPhone(bannedUser.user.cellphone) }}
                  </a>
                </td>
                <td>{{ bannedUser.description }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(bannedUser.user.updated_at) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'company-users-show',
                      params: { id: bannedUser.user.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="overflow-auto mt-5"
      v-if="companyBannedUsersPagination.lastPage > 1"
    >
      <b-pagination
        v-model="companyBannedUsersPagination.currentPage"
        :total-rows="companyBannedUsersPagination.total"
        :per-page="companyBannedUsersPagination.perPage"
        aria-controls="my-table"
        @input="updateUsers()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_COMPANY_BANNED_USERS } from "@/core/services/store/company/users.module";
import { mapGetters } from "vuex";

export default {
  name: "companyBannedUsers",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.currentUserProperty.title ?? "شرکت",
        route: { name: "company-dashboard" }
      },
      { title: "کاربران بلاک شده" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});

    this.updateUsers();
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "companyBannedUsersPagination",
      "companyBannedUsers"
    ])
  },
  methods: {
    updateUsers() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_COMPANY_BANNED_USERS)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
